import React from "react";
import Context from "../../../../context";
import CreateComponent from "./Components";

import { CustomIcon, CustomModal } from "../../../../components";

import "./index.scss";
import { useTranslation } from "react-i18next";

const Create = ({ role }: { role: "ADMIN" | "SUPER_AGENT_SCHOOL" }) => {
  // ** ===========================================================================================================
  // **                                            Value Validation
  // ** -----------------------------------------------------------------------------------------------------------
  const { setShowModal, showModal } = React.useContext(Context.CompanyScreen);

  function CreateComponentByRole() {
    switch (role) {
      case "ADMIN":
        return <CreateComponent.Administrator />;
      case "SUPER_AGENT_SCHOOL":
        return <CreateComponent.SuperAgent />;
      default:
        return <></>;
    }
  }

  const { t } = useTranslation();

  // ?? ===========================================================================================================
  // ??                                              JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------
  return (
    <section id="company-create-modal-container">
      <CustomIcon
        icon="fa-sharp fa-solid fa-circle-plus"
        size="medium"
        hoverTitle={t("createCompany")}
        onClick={() => {
          setShowModal("CREATE");
        }}
      />
      <CustomModal
        onClose={() => {
          setShowModal("NONE");
        }}
        open={showModal === "CREATE"}
        setShowModal={setShowModal}
        width={"40rem"}
        height={"85vh"}
        //closeAlert={true}
      >
        <CreateComponentByRole />
      </CustomModal>
    </section>
  );
};

export default Create;
